//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "NsProductSkuPoints",
  props: {
    /**
     * Will show points even if not distributor
     */
    forcesv: Boolean,
    /**
     * Will hide sku
     */
    hideSku: Boolean,
    /**
     * True if use is distributor
     */
    isDistributor: Boolean,
    /**
     * The amount of points
     */
    points: {
      type: String,
      default: null
    },
    /**
     * True if parent is ProductDetail
     */
    isProductDetail: Boolean,
    /**
     * Determines if the sku and points should be on separate lines
     */
    useNewLine: Boolean,
    /**
     * The sku
     */
    sku: {
      type: String,
      default: ""
    },
    /**
     * The translations
     */
    translations: {
      type: Object,
      default() {
        return {
          item: "Item",
          psv: "Points"
        };
      }
    }
  },
  computed: {
    fixedPoints() {
      return parseFloat(this.points).toFixed(2);
    },
    showSku() {
      return !this.hideSku;
    },
    showPoints() {
      return this.points && (this.isDistributor || this.forcesv);
    }
  }
};
